import i18n          from '@/lang/index.js';
import { Formatter } from '@pixul/aglaea/dist/aglaea.mjs';

const formatter = new Formatter(i18n);

export function useFormatString(value) {

  if (!value || Array.isArray(value) && value.length === 0 || typeof value === 'object' && !value.key) {
    return '-';
  }

  if (!isNaN(value)) {

    return formatter.useFormatPrice(value);
  }

  return value.value || value.key || value;
}

export function useFormatDate(value) {

  if (!value) {
    return '-';
  }

  return formatter.useFormatDate(value, true);
}